import { createRouter, createWebHistory } from 'vue-router'
import Welcome from '../views/WelcomeView.vue'

const routes = [
  {
    path: '/',
    name: 'Welcome',
    component: Welcome
  },
  {
  path: '/login',
  name: 'Login',
  component: () => import('../views/LoginView.vue')
},
{
  path: '/join',
  name: 'Join',
  component: () => import('../views/JoinView.vue')
},
  {
    path: '/ranking',
    name: 'ranking',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/RankingView.vue')
    }
  },
  {
    path: '/Game',
    name: 'Game',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/GameView.vue')
    }
  },
  {
    path: '/stats',
    name: 'stats',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/TeamStatsView.vue')
    }
  },
  {
    path: '/scoring',
    name: 'scoring',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/ScoringGame.vue')
    }
  },{
  path: '/terms',
  name: 'Terms',
  component: () => import('../views/TermsView.vue')
},{
  path: '/group',
  name: 'Group',
  component: () => import('../views/GroupManagementView.vue'),
  meta: { requiresAuth: true }
},{
  path: '/verify',
  name: 'Verify',
  component: () => import('../views/VerificationView.vue'),
  meta: { requiresAuth: true }
},{
  path: '/profileview',
  name: 'ProfileView',
  component: () => import('../views/UserProfileView.vue'),
  meta: { requiresAuth: true }
},{
  path: '/password-forget',
  name: 'PasswordForget',
  component: () => import('@/views/PasswordForget.vue')
},
{
  path: '/password-reset',
  name: 'PasswordReset',
  component: () => import('@/views/PasswordReset.vue')
}

]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
